export const environment = {
  currentEnvironment: 'integration',

  responseType: 'token id_token',
  scope: 'openid profile groups',
  requireHttps: true,
  oidc: true,
  showDebugInformation: true,
  onlineOrderingURL: 'https://ooo-i.bmwgroup.net/ooo/vi/VaVi.do?chassis=',
  forceLogoutDurationinMinutes: 30,

  internet: {
    backendBaseUrl: 'https://service.ccsp-int.aws.bmw.cloud',
    clientId: 'ea8a624f-6a72-458a-9676-42a5ce6e1217',
    redirectUrl: 'https://ccsp-int.aws.bmw.cloud',
    postLogoutRedirectUrl: 'https://ccsp-int.aws.bmw.cloud/logout',
    issuer:
      'https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2xmfaonly',
    accessTokenURL:
      'https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2xmfaonly/access_token',
  },

  intranet: {
    backendBaseUrl: 'https://ccsp-dev.used-veh-rem-dev.us-east-1.aws.cloud.bmw',
    clientId: '55fb3548-ab41-4ac2-aba5-bc186a7adaea',
    redirectUrl:
      'https://ccspui-test.used-veh-rem-test.us-east-1.aws.cloud.bmw',
    postLogoutRedirectUrl:
      'https://ccspui-test.used-veh-rem-test.us-east-1.aws.cloud.bmw/logout',
    issuer:
      'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x',
    accessTokenURL:
      'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x/access_token',
  },
};
